import moment from 'moment'
import { ROLE_LABELS } from 'utils/roles'

export const LAST_ACTIVE_HELP = `The last time this person signed in or used the platform. Only ${ROLE_LABELS.owner}s can see this.`

export const lastActiveText = (iso) => (iso ? `Active ${moment(iso).fromNow()}` : 'Not signed in yet')

export const lastActiveTitle = (iso) => (iso ? `Last active ${moment(iso).format('DD MMM YYYY, HH:mm')}` : 'This person has not signed in yet')

export const lastActiveSortValue = (iso) => (iso ? new Date(iso).getTime() : 0)

const DAY = 24 * 60 * 60 * 1000

export const ACTIVITY_STATUSES = {
  active: { key: 'active', label: 'Active', level: 'low', help: 'Used the platform in the last 30 days.' },
  quiet: { key: 'quiet', label: 'Quiet', level: 'medium', help: 'Last used the platform between 30 and 90 days ago.' },
  inactive: { key: 'inactive', label: 'Inactive', level: 'high', help: 'Has not used the platform for more than 90 days. They may have left the organisation.' },
  never: { key: 'never', label: 'Never signed in', level: 'none', help: 'Has an account but has never signed in.' },
}

export const activityStatus = (iso) => {
  if (!iso) return ACTIVITY_STATUSES.never
  const days = (Date.now() - new Date(iso).getTime()) / DAY
  if (days <= 30) return ACTIVITY_STATUSES.active
  if (days <= 90) return ACTIVITY_STATUSES.quiet
  return ACTIVITY_STATUSES.inactive
}
